var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPauseBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 31,
    height: 31,
    rx: 7,
    fill: "#F50303"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9116 12.0947C19.6414 13.2312 20.5063 13.7994 20.8067 14.5181C21.0692 15.1464 21.0692 15.8536 20.8067 16.4818C20.5063 17.2006 19.6414 17.7688 17.9116 18.9053L16.31 19.9575C14.2574 21.306 13.2312 21.9802 12.3811 21.9255C11.6404 21.8777 10.9574 21.5092 10.5108 20.9164C9.99829 20.236 9.99829 19.0081 9.99829 16.5522L9.99829 14.4478C9.99829 11.9919 9.99829 10.7639 10.5108 10.0835C10.9574 9.49072 11.6404 9.12223 12.3811 9.0745C13.2312 9.01972 14.2574 9.69397 16.31 11.0425L17.9116 12.0947Z",
    fill: "#F50303"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPauseBg);
export default __webpack_public_path__ + "static/media/icon-pause-bg.71d38b5b348530a0dd7306c86ae81d3f.svg";
export { ForwardRef as ReactComponent };